// The practice logo for the report (reports rebuild). Shared by the PDF bundle (pdf-entry.js) and the editor
// (tiptap-gate.js, Phase 2 Q2): the same read and the same decode, so the editor's colours are the PDF's.

// Decode the logo bytes into pixels for the colour extraction (downscaled; the PDF embeds the original bytes).
export async function decodeLogo(bytes, mime) {
  if (!bytes) return null;
  const type = /png/i.test(mime || '') ? 'image/png' : 'image/jpeg';
  const out = { bytes, mime: type, rgba: null, width: 0, height: 0 };
  try {
    const bmp = await createImageBitmap(new Blob([bytes], { type }));
    const sc = Math.min(1, 200 / Math.max(bmp.width, bmp.height));
    const w = Math.max(1, Math.round(bmp.width * sc)), h = Math.max(1, Math.round(bmp.height * sc));
    const cv = typeof OffscreenCanvas === 'function' ? new OffscreenCanvas(w, h) : Object.assign(document.createElement('canvas'), { width: w, height: h });
    const cx = cv.getContext('2d');
    cx.drawImage(bmp, 0, 0, w, h);
    out.rgba = cx.getImageData(0, 0, w, h).data; out.width = w; out.height = h;
  } catch (e) { console.error('❌ report pdf logo decode:', e); }
  return out;
}

// The practice logo: the same read download/share made before v2 (a 60 s signed URL on specialist-storage + one GET).
export async function fetchLogo(supa, logoPath, bucket) {
  if (!logoPath || !supa) return null;
  try {
    const { data, error } = await supa.storage.from(bucket || 'specialist-storage').createSignedUrl(logoPath, 60);
    if (error || !data?.signedUrl) { console.error('❌ report pdf logo signed URL:', error); return null; }
    const r = await fetch(data.signedUrl);
    if (!r.ok) { console.error('❌ report pdf logo fetch:', r.status); return null; }
    const blob = await r.blob();
    return decodeLogo(new Uint8Array(await blob.arrayBuffer()), blob.type || r.headers.get('content-type') || '');
  } catch (e) { console.error('❌ report pdf logo:', e); return null; }
}

// The editor's copy: one read per logo path per page load (a failed read is not cached, so the next open retries).
const _memo = new Map();
export function fetchLogoOnce(supa, logoPath, bucket) {
  if (!logoPath || !supa) return Promise.resolve(null);
  const k = (bucket || '') + '|' + logoPath;
  if (!_memo.has(k)) _memo.set(k, fetchLogo(supa, logoPath, bucket).then(l => { if (!l) _memo.delete(k); return l; }));
  return _memo.get(k);
}
